/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getCompanyDetails as getCompanyDetailsService,
  updateCompanyDetails as updateCompanyDetailsService,
} from 'dashboard409a/services/company';
import { IGetCompanyDetailsResponse } from 'dashboard409a/services/types';
import { ICompanyState } from './types';

const initialState: ICompanyState = {
  companyDetails: null,
};

export const getCompanyDetails = createAsyncThunk<IGetCompanyDetailsResponse, number>(
  'company/getCompanyDetails',
  async (companyId, thunkAPI) => {
    try {
      return await getCompanyDetailsService(companyId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateCompanyDetails = createAsyncThunk(
  'company/updateCompanyDetails',
  async (companyDetails: IGetCompanyDetailsResponse, thunkAPI) => {
    try {
      return (await updateCompanyDetailsService(companyDetails)) as unknown as IGetCompanyDetailsResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCompanyDetails.fulfilled, (state, { payload }) => {
      state.companyDetails = payload;
    });
    builder.addCase(updateCompanyDetails.fulfilled, (state, { payload }) => {
      state.companyDetails = payload;
    });
  },
});

export default companySlice.reducer;
